import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DialogLayoutAuraComponent } from '@workspace/ng-aura';

export interface PropertyApplicationWithdrawDialogData {
  hasAppointment?: boolean;
}

export interface PropertyApplicationWithdrawDialogResult {
  confirmed: boolean;
  reason?: string;
}

@Component({
  selector: 'etxe-property-application-withdraw-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    DialogLayoutAuraComponent,
  ],
  templateUrl: './property-application-withdraw-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyApplicationWithdrawDialogComponent {
  readonly dialogRef = inject(
    MatDialogRef<PropertyApplicationWithdrawDialogComponent, PropertyApplicationWithdrawDialogResult>,
  );
  readonly data = inject<PropertyApplicationWithdrawDialogData>(MAT_DIALOG_DATA, { optional: true });

  readonly reason = signal<string>('');

  readonly predefinedReasons = [
    'Désalignement sur l’estimation de prix',
    'Contraintes techniques ou état du bien',
    'Désaccord sur la stratégie commerciale',
    'Surcharge d’activité / indisponibilité',
  ];

  selectReason(predefined: string): void {
    if (this.reason() === predefined) {
      this.reason.set('');
    } else {
      this.reason.set(predefined);
    }
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      reason: this.reason().trim() || undefined,
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
